// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1gnUb","list_item":"styles_list_item__1JDgR","more":"styles_more__2Fhgm"};